module.exports = __webpack_public_path__ + "img/bgapp.16848f49.png";